"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.countBombs = exports.removeDead = exports.updateAll = exports.killAll = exports.kill = exports.setAtCrew = exports.setAtTile = exports.moveToXY = exports.setBody = exports.create = exports.findByIdSafe = exports.findById = exports.getAll = void 0;
var entitiesUtils_sidecar_1 = require("@entities/entitiesUtils-sidecar");
var assert_sidecar_1 = require("@lib/assert-sidecar");
var imports_1 = require("@lib/imports");
var mathUtils_sidecar_1 = require("@lib/mathUtils-sidecar");
var common_sidecar_1 = require("@main/common-sidecar");
var sprites_sidecar_1 = require("@sprites/sprites-sidecar");
var spritesUtil_sidecar_1 = require("@sprites/spritesUtil-sidecar");
var voyageMessageCrewCarry_sidecar_1 = require("@voyage/multi/voyageMessageCrewCarry-sidecar");
var voyageBodies_sidecar_1 = require("@voyage/entities/voyageBodies-sidecar");
var voyageCarryableData_1 = require("@voyage/entities/voyageCarryableData");
var voyageCarryableData_sidecar_1 = require("@voyage/entities/voyageCarryableData-sidecar");
var voyageGameStatus_enemyShips_sidecar_1 = require("@voyage/game-status/voyageGameStatus_enemyShips-sidecar");
var voyageLayers_sidecar_1 = require("@voyage/scene/voyageLayers-sidecar");
var voyageParticles_sidecar_1 = require("@voyage/particles/voyageParticles-sidecar");
var voyageWebsockets_sidecar_1 = require("@voyage/multi-sockets/voyageWebsockets-sidecar");
var objs = [];
function getAll() {
    return objs;
}
exports.getAll = getAll;
function findById(id) {
    return entitiesUtils_sidecar_1.entitiesUtils.findById(id, objs);
}
exports.findById = findById;
function findByIdSafe(id) {
    return entitiesUtils_sidecar_1.entitiesUtils.findByIdSafe(id, objs);
}
exports.findByIdSafe = findByIdSafe;
function create(type, id) {
    var data = voyageCarryableData_sidecar_1.voyageCarryableData.find(type);
    assert_sidecar_1.assert.notNil(data);
    var frame = data.frame;
    var image = spritesUtil_sidecar_1.spritesUtil.createImage(voyageLayers_sidecar_1.voyageLayers.getLayers().shipCrewItem, frame);
    image.rotation = data.rotation;
    image.tint = data.tint;
    spritesUtil_sidecar_1.spritesUtil.scale(image, data.scale);
    var obj = {
        id: id,
        idLoaded: -1,
        isDead: false,
        eType: 'voy-misc',
        image: image,
        body: null,
        particleTimer: 0,
        type: type,
        data: data,
        tile: null,
        crew: null,
        explosionTimer: 0,
        timeToExplode: 0,
        flickerTimer: 0,
        flickerIdx: 0,
    };
    if (obj.type === voyageCarryableData_1.EVoyageCarryableType.Breachbomb ||
        obj.type === voyageCarryableData_1.EVoyageCarryableType.Firebomb) {
        obj.timeToExplode = 30;
    }
    objs.push(obj);
    return obj;
}
exports.create = create;
function setBody(obj, body) {
    obj.body = body;
    obj.image.visible = body == null;
}
exports.setBody = setBody;
function moveToXY(obj, x, y, isFlipped) {
    if (isFlipped === void 0) { isFlipped = false; }
    // obj.x = x
    // obj.y = y
    obj.image.x = x;
    obj.image.y = y;
    obj.image.flipX = isFlipped;
    if (obj.body) {
        voyageBodies_sidecar_1.voyageBodies.moveToXY(obj.body, x, y, isFlipped);
    }
}
exports.moveToXY = moveToXY;
function setAtTile(obj, t) {
    if (obj.tile) {
        imports_1.l.remove(obj.tile.items, function (c) { return c === obj; });
        obj.tile = null;
    }
    obj.tile = t;
    if (t) {
        setAtCrew(obj, null);
        t.items.push(obj);
        moveToXY(obj, t.x + obj.data.rackOx, t.y + obj.data.rackOy);
    }
}
exports.setAtTile = setAtTile;
function setAtCrew(obj, cr) {
    if (obj.crew) {
        imports_1.l.remove(obj.crew.items, function (c) { return c === obj; });
        obj.crew = null;
    }
    obj.crew = cr;
    if (cr) {
        setAtTile(obj, null);
        cr.items.push(obj);
        obj.image.scaleX = obj.data.scale * obj.data.carryScaleX;
        obj.image.scaleY = obj.data.scale;
        moveToXY(obj, cr.x + obj.data.carryOx, cr.y + obj.data.carryOy);
    }
}
exports.setAtCrew = setAtCrew;
function kill(obj) {
    obj.isDead = true;
}
exports.kill = kill;
function killAll() {
    imports_1.l.forEach(objs, function (c) {
        kill(c);
    });
    removeDead();
}
exports.killAll = killAll;
function updateAll() {
    imports_1.l.forEach(objs, function (c) {
        update(c);
    });
    removeDead();
}
exports.updateAll = updateAll;
function removeDead() {
    entitiesUtils_sidecar_1.entitiesUtils.removeDead(objs, function (c) {
        setAtTile(c, null);
        setAtCrew(c, null);
        c.image.destroy();
    });
}
exports.removeDead = removeDead;
function update(obj) {
    var ds = common_sidecar_1.common.getUpdateDelta();
    if (obj.isDead) {
        return;
    }
    if (obj.type === voyageCarryableData_1.EVoyageCarryableType.Coffee) {
        obj.particleTimer += ds;
        var steamTime = 0.2;
        if (obj.particleTimer > steamTime) {
            obj.particleTimer -= steamTime;
            voyageParticles_sidecar_1.voyageParticles.create('steam', obj.image.x - 6, obj.image.y - 4);
        }
    }
    if (obj.type === voyageCarryableData_1.EVoyageCarryableType.Breachbomb ||
        obj.type === voyageCarryableData_1.EVoyageCarryableType.Firebomb) {
        obj.explosionTimer += ds;
        obj.flickerTimer += ds;
        var flickerTime = (obj.timeToExplode - obj.explosionTimer) / 20;
        if (obj.flickerTimer > flickerTime) {
            obj.flickerTimer = 0;
            obj.flickerIdx++;
            // let options = [sprites.voyItemBomb[0], sprites.voyItemBomb2[0]]
            var options = [sprites_sidecar_1.sprites.voyInkItemBomb1[0], sprites_sidecar_1.sprites.voyInkItemBomb2[0]];
            var scale = obj.image.scale;
            spritesUtil_sidecar_1.spritesUtil.setPackedFrame(obj.image, mathUtils_sidecar_1.mathUtils.getIndexWrapped(obj.flickerIdx, options));
            obj.image.scale = scale;
        }
        if (obj.explosionTimer >= obj.timeToExplode) {
            kill(obj);
            if (voyageWebsockets_sidecar_1.voyageWebsockets.getIsHost()) {
                voyageMessageCrewCarry_sidecar_1.voyageMessageCrewCarry.sendDestroyMessageAndImmediatelyExecute({
                    id: obj.id,
                });
                var t = obj.tile;
                if (!t) {
                    if (obj.crew) {
                        // t = obj.crew.tile
                        // TODO: hurt crew!
                    }
                }
                if (t) {
                    var chanceFire = 0;
                    var chanceBreach = 0;
                    if (obj.type === voyageCarryableData_1.EVoyageCarryableType.Breachbomb) {
                        chanceBreach = 0.5;
                    }
                    if (obj.type === voyageCarryableData_1.EVoyageCarryableType.Firebomb) {
                        chanceFire = 0.5;
                    }
                    // assert.notNil(obj.tile)
                    voyageGameStatus_enemyShips_sidecar_1.voyageGameStatus_enemyShips.hitByWeaponAt(t, 1, chanceFire, chanceBreach, true);
                }
                // voyageMessageEnemyShipCommand.sendMessageAndImmediatelyExecute({
                //   command: EVoyageEnemyShipCommand.
                // })
            }
        }
    }
}
function countBombs() {
    var num = 0;
    imports_1.l.forEach(getAll(), function (c) {
        if (c.type === voyageCarryableData_1.EVoyageCarryableType.Breachbomb ||
            c.type === voyageCarryableData_1.EVoyageCarryableType.Firebomb) {
            num++;
        }
    });
    return num;
}
exports.countBombs = countBombs;
